export const environment = {
  // username: 'TECSA_PWD',
  // password: 'tj6It6DBTrh8qWzH6e4zgHl3Ch+S2QfM+ufFMtcGJ4g=',
  // api: 'https://app.tecsa.com.my:9358/TecSA_Warehouse/api/tecsa/tecsawarehouse/v1.0',
  // username: '',
  // password: '',
  // api: '',
  username: 'ADMIN',//Zieto
  password: 'zH82OgRTFwNcMGlrsdZ8uc9LGDo1bpBIKAlWguxHqvk=',
  //client_Sandbox
  // api: 'https://api.businesscentral.dynamics.com/v2.0/000cb72f-a7a1-4bc3-9491-f20a68bd4428/Sandbox/api/tecsa/tecsawarehouse/v1.0',
  api: 'https://api.businesscentral.dynamics.com/v2.0/tecsa.com.my/procure-Sandbox/api/tecsa/tecsawarehouse/v1.0',
   // dev_Sandbox
  // api: 'https://api.businesscentral.dynamics.com/v2.0/000cb72f-a7a1-4bc3-9491-f20a68bd4428/Sandbox_dev/api/tecsa/tecsawarehouse/v1.0', // Developmment Sandbox
  production: false,
  isLive: false,
  sessionTimeout: 30,
  textLimitMax : 100,
  DocNoLimit : 20,
  demo: "hi",
  passwordCheckApi:'https://portal.tecsatech.com/api/v1/AppLogin',
  oauthTokenApi: 'https://portal.tecsatech.com/api/v1/GetBCToken',
  apiProtectionKey: '$2a$08$3hgtwuKN2zMXeJORvon.pOldOi5eqNkF3i3KLxLXdukDDigtN92By',
  productCode: 'TECSAWAREHOUSE',
  licenseApi : 'https://portal.tecsatech.com/api/V1/CheckLoginPermission',
  lisenceApiCore : "https://licensesandbox.tecsatech.com/api/V1/",

};